// 北京号H5域名
export const BASE_URL_BJH = 'https://bjhh5.bjd.com.cn/'
// 北京号问政域名
// export const BASE_URL_WEN_ZHENG = 'https://bjrbwz.bjd.com.cn'
export const BASE_URL_WEN_ZHENG = 'https://app.bjd.com.cn'
// export const BASE_URL_WEN_ZHENG = '/app'

// 北京号号主页跳转url
export const MASTER_URL = BASE_URL_BJH + 'master?column_id='
// 北京号主页
export const BASE_URL_BJD = 'https://bjh.bjd.com.cn/'
